export default class ChatInteractionEvent {
    constructor(type) {
        this.type = type;
    }
}

ChatInteractionEvent.NEW_PLAYER_OPTIONS_AVAILABLE = 'ChatInteractionEvent.NEW_PLAYER_OPTIONS_AVAILABLE';

ChatInteractionEvent.CHAT_STARTED = 'ChatInteractionEvent.CHAT_STARTED';
ChatInteractionEvent.CHAT_ENDED = 'ChatInteractionEvent.CHAT_ENDED';

ChatInteractionEvent.CHAT_STATUS_CHANGED = 'ChatInteractionEvent.CHAT_STATUS_CHANGED';